//firebase config stuff

export default {
  apiKey: "AIzaSyC0nC61sbImFH0Z5LKdK5IcJxrAJfOZmOU",
  authDomain: "mygitapp-322d2.firebaseapp.com",
  databaseURL: "https://mygitapp-322d2.firebaseio.com",
  projectId: "mygitapp-322d2",
  storageBucket: "mygitapp-322d2.appspot.com",
  messagingSenderId: "649312786767",
  appId: "1:649312786767:web:c9f10b809848cd125acd3a",
  measurementId: "G-LDKH1NZXL0",
};
